﻿import { defineStore } from 'pinia'

export const useHostNameStore = defineStore('hostname', {
  state: () => ({
    hostname: getShortHostname(),
    environment: getShortHostname() === 'localhost' ? 'development' : window.location.hostname.includes('staging') ? 'staging' : 'production'
  }),
});

function getShortHostname() {
  let hostname = window.location.hostname;
  hostname = hostname.replace('staging.', ''); // remove www. for
  return hostname

  const parts = hostname.split('.');
  let extractedPart = '';
  if (parts.length >= 2) {
    extractedPart = parts[parts.length - 2];
    if (parts.length > 2 && parts[parts.length - 2] === 'dn') {
      extractedPart = parts[parts.length - 3];
    }
  }
  else
    extractedPart = hostname
  return extractedPart;
}